export default "__VITE_ASSET__uImvzEkl__"